window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    const transitionDiv = document.querySelector('.page-transition.previous-page');
    if (transitionDiv) {
      transitionDiv.remove();
    }
  }
});

document.querySelectorAll('[data-product-select]').forEach((link) => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    const href = link.getAttribute('href');

    const transitionDiv = document.createElement('div');
    transitionDiv.classList.add('page-transition', 'cover', 'previous-page');

    const loadingBar = document.createElement('div');
    loadingBar.classList.add('page-transition__loading-bar', 'load');

    transitionDiv.appendChild(loadingBar);

    document.body.appendChild(transitionDiv);

    loadingBar.addEventListener('animationend', () => {
      loadingBar.classList.remove('load');
      loadingBar.style.transform = 'scaleX(1)';
      loadingBar.classList.add('fade-out');
    });

    sessionStorage.setItem('runOnload', 'true');

    setTimeout(() => {
      window.location.href = href;
    }, 1000);
  });
});

window.onbeforeunload = () => {
  (document.querySelector('.page-transition') as HTMLElement).style.display = 'block';
};

window.onload = () => {
  const transitionDiv = document.querySelector('[data-page-transition]');

  if (transitionDiv) {
    if (sessionStorage.getItem('runOnload')) {
      transitionDiv.classList.add('uncover');

      transitionDiv.addEventListener('animationend', () => {
        transitionDiv.classList.remove('page-transition', 'uncover');

        sessionStorage.removeItem('runOnload');
      });
    } else {
      transitionDiv.classList.remove('page-transition');
    }
  }
};
